import React from "react";
import { PROCESS_STEPS } from "../data/mock";

const ProcessSection = () => {
  return (
    <section className="py-24 md:py-36 bg-neutral-50 relative overflow-hidden">
      <div className="max-w-[1300px] mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-black/10 text-xs uppercase tracking-[0.2em] font-semibold text-neutral-700">
            Arbeitsweise
          </span>
          <h2 className="font-display font-extrabold text-4xl md:text-6xl lg:text-7xl tracking-[-0.03em] leading-[1.02] mt-6 text-neutral-950">
            Strukturiert.{" "}
            <span className="bg-gradient-to-r from-pink-500 via-orange-500 to-purple-500 bg-clip-text text-transparent">
              Transparent. Langfristig.
            </span>
          </h2>
          <p className="mt-6 text-lg md:text-xl text-neutral-600 leading-relaxed">
            Kein Aktionismus. Wir bauen ein System – Schritt für Schritt, mit
            klaren Etappen und messbaren Ergebnissen.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {PROCESS_STEPS.map((p, idx) => (
            <div
              key={idx}
              className="relative p-7 rounded-3xl bg-white border border-black/5 hover:border-pink-200 hover:shadow-[0_20px_50px_-20px_rgba(236,72,153,0.25)] hover:-translate-y-1 transition-all duration-500"
            >
              <div className="font-display font-extrabold text-5xl bg-gradient-to-br from-pink-500 via-orange-500 to-purple-500 bg-clip-text text-transparent">
                {p.step}
              </div>
              <h3 className="mt-5 font-display font-extrabold text-xl tracking-tight text-neutral-950">
                {p.title}
              </h3>
              <p className="mt-3 text-sm text-neutral-600 leading-relaxed">
                {p.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
